import React, { useState } from "react";
import { AppContext } from "../AppContext";
import { BaseInquiryToolBar } from "../modules/BaseModule";
import {
  FormLabel,
  Col,
  Row,
  FormControl,
  Button,
  Table,
} from "react-bootstrap";
import {
  ShowError,
  ColumnDefinition,
  InputTextbox,
  DatePickerComponent_adv,
  ProgressBar,
  AlertToolBox,
  MultiViewPopup,
} from "../gui_components/UIComponents";
import {
  isEmpty,
  isEmptyArray,
  isEmptyString,
} from "../gui_components/Util.js";
import {
  CriticalPathManagementInquiryCriteria,
  CustomerSearchCriteria,
  PageListBean,
  RestCustomerListRequest,
  FabricStyleSearchCriteria,
  RestFabricStyleListBeanRequest,
  RestPageListBean,
  RestReadRequest,
  RestSalesPriceInquiryListRequest,
  RestCpmReportDetailsListRequest,
} from "../ds/ds";
import { BaseBean, RestReportBean } from "../ds/client_ds.js";
import { PopupCpmModule } from "../modules/ModuleUtil.js";
import { ReportService } from "../services/ReportService.js";
import { ConfigManager } from "../config/ConfigManager.js";
import { CustomerLookupHandler } from "../lookup/CustomerLookupHandler";
import { CustomerService } from "../services/CustomerService.js";
import CustomTable from "../gui_components/CustomTable.js";
import { AddIcon } from "../gui_components/Icons.js";
import { SecurityAccessManager } from "../security/SecurityAccessManager.js";
class CpmInq extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {
      pageTitle: "CPM Report Inquiry",
      isShowExecuteButton: true,
      isShowClearCriteriaButton: true,
      isShowExitButton: true,
      isShowClearErrorButton: true,
      criteria: new CriticalPathManagementInquiryCriteria(),
      isShowAutoCompleteCustomerCodeList: false,
      customerPageListForAutoCompleteList: new Array(),
      showAutoCompleteCustomerList: null,
      fabricPageListForAutoCompleteList: new Array(),
      showAutoCompleteFabricList: null,
      is3PL: false,
      fabricLookupHandler: null,
      customerLookupHandler: null,
      isDisableFields: false,
      inquiryDataList: [],
      error_list: [],
      isShowAlert: false,
      alertMessage: "",
      success_list: [],
      isShowResetButton: false,
      isShowPDFButton: false,
      isShowExcelButton: false,
      isShowProgressBarPopup: false,
      progressLoadingText: "",
      isShowInvoiceModule: false,
      isShowCustomerModule: false,
      isShowFabricStyleModule: false,
      isInquiryDatasFound: false,
      is3PL: false,
      salesPersonPageListForAutoCompleteList: new Array(),
      showAutoCompleteSalesPersonList: true,
      cpmDataList: [],
      isShowLinePopup: false,
      isShowCpmModule: false,
      viewDetailsTable: false,
      ind_Row: null,
      add_Icon: false,
    };
  }
  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    this.report_url = appData.reportURL;
    const { cache } = appData;
    if (ConfigManager.isPurchaseBasedOnCustomerFlag()) {
      this.state.is3PL = true;
      this.setState({
        is3PL: true,
      });
    }
    this.cache = cache;
    const attribute_cache = { ...cache };

    this.initLookupHandlers();
  }
  viewCpmModule = (e, code, rowData) => {
    if (e.detail === 1) {
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowCpmModule: true,
          moduleForPopup: (
            <PopupCpmModule code={code} onModuleExit={this.onPopupModalExit} />
          ),
        });
      }
    }
  };
  closeModalCallBack = (isOpen) => {
    this.setState({
      isShowLinePopup: isOpen,
      isShowCpmModule: isOpen,
      moduleForPopup: [],
    });
  };
  initLookupHandlers = () => {
    const customerLookupHandler = new CustomerLookupHandler(
      this.companyCode,
      "customerCode"
    );
    this.setState({
      customerLookupHandler: customerLookupHandler,
    });
  };
  onModuleExit = () => {
    this.props.onModuleExit();
  };

  execute = () => {
    this.hideAlertCallBack();
    this.loadPage(1);
  };
  hideAlertCallBack = (msgType, isDisplayed) => {
    this.setState({ isShowAlert: isDisplayed, error_list: [] });
  };

  inquiryColumns = () => {
    const columns = new Array();
    columns.push(
      new ColumnDefinition()
        .setDetails("", <AddIcon />, false)
        .setStyleDetails("center", "2", "", "wt-2", "wt-2")
        .setClickDetails(true, true, this.cpmClick, <AddIcon />)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("CPM", "cpmCode", true)
        .setStyleDetails("left", "2", "", "wt-2", "wt-2")
        .setClickDetails(true, false, this.viewCpmModule, null)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Customer", "customerCode", true)
        .setStyleDetails("left", "4", "", "wt-4", "wt-4")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("CustomerName", "customerName", true)
        .setStyleDetails("left", "4", "", "wt-4", "wt-4")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Container", "containerNumber", true)
        .setStyleDetails("left", "2", "2", "wt-2", "wt-2")
    );

    return columns;
  };

  //   inquiryColumns
  cpmClick = (e, rowData, id) => {
    if (e.detail === 1) {
      let cpmDataList = [];
      if (rowData.cpmDetailInfos != null) {
        cpmDataList = rowData.cpmDetailInfos;
        this.setState({
          cpmDataList: cpmDataList,
          viewDetailsTable: true,
          add_Icon: true,
          ind_Row: id,
        });
      }
    }
  };

  cpmMinusClick = (e) => {
    if (e.detail === 1) {
      let cpmDataList = [];
      this.setState({
        cpmDataList: cpmDataList,
        viewDetailsTable: false,
        add_Icon: true,
        ind_Row: null,
      });
    }
  };
  // closeAlertModalCallBack = (isShowPopup) => {
  //   this.setState({
  //     isShowLinePopup: isShowPopup,
  //   });
  // };
  cpmInfoColumns = () => {
    const columns = new Array();
    columns.push(
      new ColumnDefinition()
        .setDetails("Task", "taskCode", true)
        .setStyleDetails("left", "2", "", "wt-2", "wt-2")
      //  .setClickDetails(true, false, this.viewInvoiceModule, null)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Sched_Date", "scheduledDate", true)
        .setStyleDetails("left", "2", "2", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Sched_Time", "scheduledTime", true)
        .setStyleDetails("left", "2", "2", "wt-2", "wt-2")
      //   .setClickDetails(true, false, this.viewCustomerModule, null)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("StartDate", "startDate", true)
        .setStyleDetails("left", "2", "2", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("StartTime", "startTime", true)
        .setStyleDetails("left", "2", "2", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("EndDate", "endDate", true)
        .setStyleDetails("left", "2", "2", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("EndTime", "endTime", true)
        .setStyleDetails("left", "2", "2", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Duration(Hours)", "duration", true)
        .setStyleDetails("right", "2", "2", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Comments", "comments", true)
        .setStyleDetails("left", "2", "2", "wt-2", "wt-2")
    );

    return columns;
  };
  // viewFabricModule = (e, code, rowData) => {
  //   if (e.detail === 1) {
  //     if (code !== "" && code !== undefined) {
  //       this.setState({
  //         isShowFabricStyleModule: true,
  //         moduleForPopup: (
  //           <PopupFabricStyleModule
  //             fabricStyleCode={code}
  //             onModuleExit={this.onPopupModalExit}
  //           />
  //         ),
  //       });
  //     }
  //   }
  // };
  // viewInvoiceModule = (e, code, rowData) => {
  //   if (e.detail === 1) {
  //     if (code !== "" && code !== undefined) {
  //       this.setState({
  //         isShowInvoiceModule: true,
  //         moduleForPopup: (
  //           <PopupInvoiceModule
  //             invoiceCode={code}
  //             onModuleExit={this.onPopupModalExit}
  //           />
  //         ),
  //       });
  //     }
  //   }
  // };

  // viewCustomerModule = (e, code, rowData) => {
  //   if (e.detail === 1) {
  //     if (code !== "" && code !== undefined) {
  //       this.setState({
  //         isShowCustomerModule: true,
  //         moduleForPopup: (
  //           <PopupCustomerModule
  //             customerCode={code}
  //             onModuleExit={this.onPopupModalExit}
  //           />
  //         ),
  //       });
  //     }
  //   }
  // };

  showErrorMessage = (response) => {
    if (response.errors != null) {
      let errMsg = "";
      let errList = [];
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        )
      );
      this.setState({ error_list: errList });
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  showInfoMessage = (response) => {
    if (response.infos != null) {
      let infoMsg = "";
      let successList = [];
      response.infos.map(
        (info) => (
          (infoMsg = infoMsg + info.messageDescription),
          successList.push(info.messageDescription)
        )
      );
      this.setState({
        alertMessage: successList,
        alertType: "success",
        isShowAlert: true,
      });
    }
  };
  validate = (data) => {
    let isValid = false;
    let err_list = [];
    let errorMessage = "";
    let errMsg = "";
    if (
      isEmptyString(data.customerCode) &&
      isEmptyString(data.fabricStyleCode)
    ) {
      if (this.state.is3PL) {
        errMsg = "Customer Code/Item is Required";
      } else {
        errMsg = "Customer Code/FabricCode is Required";
      }
      errorMessage = errorMessage + errMsg;
      err_list.push(errMsg);
    }
    if (err_list.length > 0) {
      isValid = false;
      this.setState({
        alertMessage: err_list,
        alertType: "danger",
        isShowAlert: true,
        isLoading: false,
        isShowProgressBarPopup: false,
        progressLoadingText: "",
      });
    } else {
      isValid = true;
      this.setState({ isShowAlert: false });
    }
    return isValid;
  };
  inValidAccess = (type) => {
    let errMsg = "Access Denied";
    if (type == 1) {
      errMsg = "Access Denied";
    } else if (type == 2) {
      errMsg = "PDF Access Denied";
    } else if (type == 3) {
      errMsg = "EXCEL Access Denied";
    } else if (type == 4) {
      errMsg = "Mail Access Denied";
    }
    let errList = [];
    errList.push(errMsg);
    this.setState({
      alertMessage: errList,
      alertType: "danger",
      isShowAlert: true,
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  loadPage = (pageNumber) => {
    let criteria = this.state.criteria;
    criteria.companyCode = this.companyCode;

    // let isValid = false;
    // isValid = this.validate(criteria);
    // if (isValid) {
    this.loadCpmInquiryList(criteria);
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Executing...",
    });
    // }
  };
  loadCpmInquiryList = (criteria) => {
    if (SecurityAccessManager.cpmReportInquiry_IsAccessible()) {
      ReportService.inquireCpmDetailReport(
        criteria,
        this.loadCpmReportPageListResponse,
        this.errorCallBack
      );
    } else {
      this.inValidAccess(1);
    }
  };
  loadCpmReportPageListResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.cpmDetail != null) {
      let customerSalesDataList = [];
      let inquiryDataList = response.data.cpmDetail;
      if (!isEmptyArray(response.data.cpmDetail.infos)) {
        customerSalesDataList = response.data.cpmDetail.infos;
        // customerSalesDataList.map((line, i) => {
        //   const formatter = new Intl.NumberFormat('en-US', { minimumFractionDigits: 2 });
        //   line.price = formatter.format(line.price);
        //   line.quantity = formatter.format(line.quantity);
        // });
        this.setState({
          isShowPDFButton: true,
          isShowExcelButton: true,
        });
      }
      this.setState({
        isInquiryDatasFound: true,
        isShowResetButton: true,
        isShowClearCriteriaButton: false,
        inquiryDataList: customerSalesDataList,
        isCollapsible_open: false,
        isShowProgressBarPopup: false,
        progressLoadingText: "",
        inquiryData: inquiryDataList,
      });
      this.disable();
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  disable = () => {
    this.setState({
      isDisableFields: true,
      isShowServiceLookup: false,
    });
  };

  hideAlertCallBack = (msgType, isDisplayed) => {
    this.setState({ isShowAlert: isDisplayed, error_list: [] });
  };

  errorCallBack = (error) => {
    ShowError(error);
    this.setState({
      isLoading: false,
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };

  onCustomerCodeChange = (e) => {
    let customerCode = e.target.value;
    this.state.showAutoCompleteCustomerList = true;
    let tempCriteria = this.state.criteria;
    let showAutoCompleteList = this.state.showAutoCompleteCustomerList;
    if (isEmpty(customerCode)) {
      this.state.showAutoCompleteCustomerList = false;
      let showAutoCompleteList = this.state.showAutoCompleteCustomerList;
      let criteria = this.state.criteria;
      criteria.customerCode = "";
      criteria.customerName = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteList: showAutoCompleteList,
        criteria: criteria,
        customerPageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "customerCode" &&
      showAutoCompleteList === true &&
      customerCode !== ""
    ) {
      this.readCustomerBySearchString(e.target.value);
    }
    tempCriteria[e.target.name] = e.target.value;
    this.setState({ criteria: tempCriteria });
  };
  readandsetCustomerDetailResponse = (response) => {
    let criteria = this.state.criteria;
    if (response.data != null && response.data.customer != null) {
      let customerData = response.data.customer;

      if (!isEmpty(customerData)) {
        criteria.customerName = customerData.description;
        criteria.customerCode = customerData.code;
        this.setState({
          criteria: criteria,
        });
      }
    }
  };
  readandsetCustomerDetail = (customerCode) => {
    let input = new RestReadRequest();
    input.companyCode = this.companyCode;
    input.code = customerCode;
    input.isLoadChildren = true;
    CustomerService.readCustomer(
      input,
      this.readandsetCustomerDetailResponse,
      this.errorCallBack
    );
  };
  readCustomerBySearchString(searchString) {
    let searchCriteria = new CustomerSearchCriteria();
    searchCriteria.companyCode = this.companyCode;
    searchCriteria.customerCodeStartsWith = searchString;
    searchCriteria.customerNameContains = searchString;
    let cust_pageList = new RestPageListBean();
    cust_pageList.pageSize = 100;
    let cust_requestInput = new RestCustomerListRequest();
    cust_requestInput.pageInput = cust_pageList;
    cust_requestInput.searchCriteria = searchCriteria;
    CustomerService.getCustomerPageList(
      cust_requestInput,
      this.readByCustomerCodeResponse,
      this.errorCallBack
    );
  }
  readByCustomerCodeResponse = (response) => {
    let customerData = response.data.customerPageList.customers;
    let simpleAutoCompleteList = new Array();
    if (customerData.length > 0 && customerData != null) {
      customerData.map((customer) => {
        let simpleItemBean = {
          code: customer.code,
          description: customer.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    this.setState({
      customerPageListForAutoCompleteList: simpleAutoCompleteList,
    });
  };
  customerCodeEnterKeyEventHandler = (e) => {
    let customerCode = e.target.value;
    this.readandsetCustomerDetail(customerCode);
    this.setState({
      customerPageListForAutoCompleteList: new Array(),
    });
  };
  displayAutoCompleteList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteCustomerList: showAutoCompleteList });
  };

  clearError = () => {
    this.setState({ error_list: [] });
  };
  clearCriteria = () => {
    let criteria = new CriticalPathManagementInquiryCriteria();
    criteria.companyCode = this.companyCode;
    criteria.customerName = "";

    this.setState({
      criteria: criteria,
      isDisableFields: false,
      isShowResetButton: false,
      isShowClearCriteriaButton: true,
    });
    this.hideAlertCallBack();
  };
  resetInquiry = () => {
    let criteria = new CriticalPathManagementInquiryCriteria();
    criteria.companyCode = this.companyCode;
    criteria.customerName = "";
    this.setState({
      criteria: criteria,
      isInquiryDatasFound: false,
      inquiryDataList: new Array(),
      isShowPDFButton: false,
      isShowExcelButton: false,
      isShowColorLookup: false,
      isShowResetButton: false,

      isDisableFields: false,
      isShowClearCriteriaButton: true,
    });
    this.hideAlertCallBack();
  };
  hideAlertCallBack = (msgType, isDisplayed) => {
    this.setState({ isShowAlert: isDisplayed, error_list: [] });
  };

  generateReport = (reportType) => {
    let criteria = this.state.criteria;
    criteria.companyCode = this.companyCode;
    let reportBean = new RestReportBean();
    reportBean.reportType = reportType;
    let pageInput = new RestPageListBean();
    // pageInput.pageSize = 20;
    // pageInput.currentPage = 1;
    let listRequest = new RestCpmReportDetailsListRequest();
    listRequest.searchCriteria = criteria;
    listRequest.reportBean = reportBean;
    listRequest.pageInput = pageInput;
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Generating Report...",
    });
    if (reportBean.reportType == 1) {
      if (SecurityAccessManager.cpmReportInquiryPDFReport_IsAccessible()) {
        ReportService.generateCpmReportDetailsPrintReport(
          listRequest,
          this.generateCpmReportPageResponse,
          this.errorCallBack
        );
      } else {
        this.inValidAccess(2);
      }
    } else if (reportBean.reportType == 2) {
      if (SecurityAccessManager.cpmReportInquiryExcelReport_IsAccessible()) {
        ReportService.generateCpmReportDetailsPrintReport(
          listRequest,
          this.generateCpmReportPageResponse,
          this.errorCallBack
        );
      } else {
        this.inValidAccess(3);
      }
    }
  };
  generateCpmReportPageResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.reportResult != null) {
      if (!isEmptyString(response.data.reportResult.reportFileID)) {
        let reportFilePath = response.data.reportResult.reportFileID;
        window.open(this.report_url + reportFilePath);
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  generatePDF = () => {
    this.generateReport(1);
  };
  generateExcel = () => {
    this.generateReport(2);
  };
  onPopupModalExit = () => {
    this.closeModalCallBack(false);
  };
  onChange = (e) => {
    let criteria = this.state.criteria;
    criteria[e.target.name] = e.target.value;
    this.setState({ criteria: criteria });
  };

  render() {
    const inquiryDataList = this.state.inquiryDataList;
    const cpmDataList = this.state.cpmDataList;
    return (
      <div>
        <ProgressBar
          progressLoadingText={this.state.progressLoadingText}
          isShowPopup={this.state.isShowProgressBarPopup}
        />

        <AlertToolBox
          alertMsgList={this.state.alertMessage}
          alertErrorType={this.state.alertType}
          isShowAlert={this.state.isShowAlert}
          hideAlertCallBack={this.hideAlertCallBack}
        />
        <BaseInquiryToolBar
          pageTitle={this.state.pageTitle}
          isShowExecuteButton={this.state.isShowExecuteButton}
          isShowClearCriteriaButton={this.state.isShowClearCriteriaButton}
          isShowClearErrorButton={this.state.isShowClearCriteriaButton}
          isShowExitButton={this.state.isShowExitButton}
          isShowResetButton={this.state.isShowResetButton}
          isShowPDFButton={this.state.isShowPDFButton}
          isShowExcelButton={this.state.isShowExcelButton}
          onModuleExit={this.onModuleExit}
          execute={this.execute}
          reset={this.resetInquiry}
          generatePDF={this.generatePDF}
          generateExcel={this.generateExcel}
          clearCriteria={this.clearCriteria}
          clearError={this.clearError}
        />
        <CriteriaView
          {...this.state}
          loadPage={this.loadPage}
          onChange={this.onChange}
          criteria={this.state.criteria}
          customerLookupHandler={this.state.customerLookupHandler}
          onCustomerCodeChange={this.onCustomerCodeChange}
          customerCodeEnterKeyEventHandler={
            this.customerCodeEnterKeyEventHandler
          }
          displayAutoCompleteList={this.displayAutoCompleteList}
        />

        {/* {this.state.isInquiryDatasFound && (

          <div className="mt-3">
            <CustomTable
              data={inquiryDataList}
              columns={this.inquiryColumns()}
             // enableVritualizer={true}
            />
           </div> 
        )} */}

        {this.state.isInquiryDatasFound && (
          <div className="div_default">
            <Table id="fabrics_tables_default">
              <thead>
                <tr>
                  <th></th>
                  <th>CPM</th>
                  <th>Customer</th>
                  <th>CustomerName</th>
                  <th>Container</th>
                </tr>
              </thead>

              {/*this.state.isInquiryDatasFound && this.getSummaryDetail()*/}
              {inquiryDataList.map((inquiryInfo, mainIndex) => (
                <tbody>
                  <tr key={mainIndex}>
                    <td>
                      {/* <Button
                        variant="secondry"
                        className="hyperLinkText"
                        onClick={(e) => this.cpmClick(e, inquiryInfo)}
                      >
                        <AddIcon />
                      </Button> */}
                      {this.state.add_Icon === true &&
                      this.state.ind_Row === mainIndex ? (
                        <Button
                          variant="secondry"
                          className="hyperLinkText"
                          onClick={(e) => this.cpmMinusClick(e, inquiryInfo)}
                        >
                          <i class="fa-light fa-minus">-</i>
                        </Button>
                      ) : (
                        <Button
                          variant="secondry"
                          className="hyperLinkText"
                          onClick={(e) =>
                            this.cpmClick(e, inquiryInfo, mainIndex)
                          }
                        >
                          <AddIcon />
                        </Button>
                      )}
                    </td>
                    <td>
                      <Button
                        variant="secondry"
                        className="hyperLinkText"
                        onClick={(e) =>
                          this.viewCpmModule(e, inquiryInfo.cpmCode)
                        }
                      >
                        {inquiryInfo.cpmCode}
                      </Button>
                    </td>
                    <td>{inquiryInfo.customerCode}</td>
                    <td>{inquiryInfo.customerName}</td>
                    <td>{inquiryInfo.containerNumber}</td>
                  </tr>
                  {this.state.isInquiryDatasFound &&
                    this.state.viewDetailsTable &&
                    this.state.ind_Row === mainIndex && (
                      <tr>
                        <td colspan="6">
                          <Table id="fabrics_tables_default">
                            <thead>
                              <tr>
                                <th>Task</th>
                                <th>Sched_Date</th>
                                <th>Sched_Time</th>
                                <th>StartDate</th>
                                <th>StartTime</th>
                                <th>EndDate</th>
                                <th>EndTime</th>
                                <th>Duration(Hours)</th>
                                <th>Comments</th>
                              </tr>
                            </thead>
                            {cpmDataList != null && (
                              <tbody>
                                {cpmDataList.map((data, childIndex) => (
                                  <tr key={childIndex}>
                                    <td>{data.taskCode}</td>
                                    <td>{data.scheduledDate}</td>
                                    <td>{data.scheduledTime}</td>
                                    <td>{data.startDate}</td>
                                    <td>{data.startTime}</td>
                                    <td>{data.endDate}</td>
                                    <td>{data.endTime}</td>
                                    <td>{data.duration}</td>
                                    <td>{data.comments}</td>
                                  </tr>
                                ))}
                              </tbody>
                            )}
                          </Table>
                          {/* )} */}
                        </td>
                      </tr>
                    )}
                </tbody>
              ))}
            </Table>
          </div>
        )}

        <MultiViewPopup
          isModulePopup={false}
          isShowPopup={this.state.isShowLinePopup}
          closeOnEsc={false}
          popupLvlClass={"popupSizeLevel1"}
          closeAlertModalCallBack={this.closeModalCallBack}
          title={"Line Details"}
          closeOnDocumentClick={false}
          lineFunctionalityForm={this.lineFunctionalityForm}
          alertContainerBox={
            <AlertToolBox
              alertMsgList={this.state.alertMessage}
              alertErrorType={this.state.alertType}
              isShowAlert={this.state.isShowAlert}
              hideAlertCallBack={this.hideAlertCallBack}
            />
          }
          content={
            <div>
              <div className="mt-3">
                <CustomTable
                  data={cpmDataList}
                  columns={this.cpmInfoColumns()}
                  enableVritualizer={true}
                />
              </div>
            </div>
          }
        />

        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          popupLvlClass={"popupSizeLevel0"}
          isShowPopup={this.state.isShowCpmModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        ></MultiViewPopup>
        {/* <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          popupLvlClass={"popupSizeLevel1"}
          isShowPopup={this.state.isShowCustomerModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        ></MultiViewPopup>
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          popupLvlClass={"popupSizeLevel0"}
          isShowPopup={this.state.isShowFabricStyleModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        ></MultiViewPopup> */}
      </div>
    );
  }
}
export function CriteriaView(props) {
  let criteria = props.criteria;
  const onChange = (e) => props.onChange(e);

  let customerLookupHandler = props.customerLookupHandler;
  let isDisableFields = props.isDisableFields;

  return (
    <div>
      <Row className="d-flex justify-content-left">
        <Col sm="1">
          <FormLabel>Customer</FormLabel>
        </Col>
        <Col sm="2">
          <InputTextbox
            onChange={props.onCustomerCodeChange}
            disabled={isDisableFields}
            name="customerCode"
            placeholder="Customer"
            value={criteria.customerCode}
            lookupRequired={true}
            lookupHandler={customerLookupHandler}
            showCriteriaDialog={true}
            enterKeyEventHandler={props.customerCodeEnterKeyEventHandler}
            autoCompleteListData={props.customerPageListForAutoCompleteList}
            enableAutoCompleteTextBox={true}
            displayAutoCompleteList={props.displayAutoCompleteList}
            showAutoCompleteList={props.showAutoCompleteCustomerList}
            isMandatory={true}
          />
        </Col>
        <Col sm="3">
          <InputTextbox
            disabled={true}
            name="customerName"
            value={criteria.customerName}
          />
        </Col>
        <Col sm="1">
          <FormLabel>Container</FormLabel>
        </Col>
        <Col sm="2">
          <InputTextbox
            name="containerNumber"
            onChange={onChange}
            value={criteria.containerNumber}
            disabled={props.isDisableFields}
          />
        </Col>
        <Col sm="1">
          <FormLabel>Status</FormLabel>
        </Col>
        <Col sm="2">
          <FormControl
            as="select"
            onChange={onChange}
            name="cpmStatus"
            value={criteria.cpmStatus}
            disabled={props.isDisableFields}
          >
            <option value={""}>All</option>
            <option value={"O"}>Open</option>
            <option value={"F"}>Finished</option>
          </FormControl>
        </Col>
      </Row>
      <Row>
        <Col sm="1">
          <FormLabel>From Date</FormLabel>
        </Col>
        <Col sm="2">
          <DatePickerComponent_adv
            name="fromCpmScheduledDate"
            value={criteria.fromCpmScheduledDate}
            onChange={onChange}
            disabled={props.isDisableFields}
          />
        </Col>
        <Col sm="1">
          <FormLabel>To Date</FormLabel>
        </Col>
        <Col sm="2">
          <DatePickerComponent_adv
            name="toCpmCpmScheduledDate"
            value={criteria.toCpmCpmScheduledDate}
            onChange={onChange}
            disabled={props.isDisableFields}
          />
        </Col>
      </Row>
    </div>
  );
}

function CpmInquiry(props) {
  return (
    <div id="moduleContainer" className="module_container">
      <div className="App">
        <CpmInq {...props} name="" /> <br />
      </div>
    </div>
  );
}

export default CpmInquiry;
